import { createSlice } from '@reduxjs/toolkit'

export const enableButton = createSlice({
  name: 'enableButton',
  initialState: { enable: false },
  reducers: {
    setEnableButton: (state, action) => {
      state.enable = action.payload
    },
  },
})

export const { setEnableButton } = enableButton.actions
export default enableButton.reducer
